"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputEventObserver = void 0;
var inversify_1 = require("inversify");
var event_tracking_core_1 = require("@al/event-tracking-core");
var utils_1 = require("../utils");
var processor_1 = require("../utils/processor");
var notifyEvents_1 = require("../constants/notifyEvents");
var InputEventObserver = /** @class */ (function () {
    function InputEventObserver() {
    }
    InputEventObserver.prototype.collectData = function (element) {
        var data = (0, processor_1.processDataset)((0, utils_1.collectDataFromDataset)(element, event_tracking_core_1.INPUT_DATASET_KEY));
        return __assign(__assign({}, data), { inputContent: element === null || element === void 0 ? void 0 : element.value });
    };
    InputEventObserver.prototype.update = function (event) {
        var data = this.collectData(event.target);
        if (!data || (data && !data.inputKey)) {
            return;
        }
        this.observableService.notify(notifyEvents_1.NOTIFY_INPUT_EVENT, {
            data: data,
            event: event,
        });
    };
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IObservableService),
        __metadata("design:type", Object)
    ], InputEventObserver.prototype, "observableService", void 0);
    InputEventObserver = __decorate([
        (0, inversify_1.injectable)()
    ], InputEventObserver);
    return InputEventObserver;
}());
exports.InputEventObserver = InputEventObserver;
